import { Container, Eyebrow, PillButton } from '../home/ui';

const NotFound = () => (
  <section className="relative min-h-screen flex items-center overflow-hidden bg-linear-to-b from-[#d5d9e3] to-[#e9ecf2] pt-28 pb-20">
    {/* Soft blue glow, same palette as the hero portrait arch */}
    <div
      aria-hidden="true"
      className="absolute top-[40%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[560px] h-[380px] sm:w-[760px] sm:h-[480px] rounded-full pointer-events-none bg-[radial-gradient(ellipse_at_center,rgba(59,91,253,0.28)_0%,rgba(111,134,255,0.14)_45%,transparent_72%)]"
    />

    <Container className="relative z-10 w-full text-center">
      <div
        aria-hidden="true"
        className="select-none font-bold leading-[0.85] tracking-[-0.06em] text-[38vw] sm:text-[220px] lg:text-[260px]"
      >
        <span className="inline-block px-[0.06em] bg-linear-to-b from-[#3b5bfd] via-[#6f86ff] to-[#6f86ff]/0 bg-clip-text text-transparent">
          404
        </span>
      </div>

      <Eyebrow className="mt-2">Page Not Found</Eyebrow>

      <h1 className="mt-4 text-[34px] sm:text-[46px] font-medium leading-[1.05] tracking-[-0.045em] text-[#111]">
        This page took a wrong turn.
      </h1>

      <p className="mt-4 max-w-[440px] mx-auto text-[15px] sm:text-base leading-relaxed text-[#111]/70">
        The page you're looking for doesn't exist, was moved, or the link is out of date.
      </p>

      <div className="mt-9">
        <PillButton to="/">Back to Home</PillButton>
      </div>
    </Container>
  </section>
);

export default NotFound;
